@.getCookie = (c_name) ->
    if document.cookie.length > 0
        c_start = document.cookie.indexOf(c_name + '=')
        if c_start != -1
            c_start = c_start + c_name.length + 1
            c_end = document.cookie.indexOf(';', c_start)
            if c_end == -1
                c_end = document.cookie.length
            return unescape(document.cookie.substring(c_start, c_end))
    ''
@.setCookie = (c_name, value, exdays) ->
    exdate = new Date()
    exdate.setDate(exdate.getDate() + exdays)
    c_value = escape(value) + '; expires=' + exdate.toUTCString()
    document.cookie = c_name + '=' + c_value + ';path=/'


@.validateEmail = (email) ->
    re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());

@.generalSiteHandler = (disableSurvey = false) ->
    eventFired = false
    @disableSurvey = disableSurvey
    window.gridBreakpoints = {
        xs: 0
        sm: 576
        md: 768
        lg: 992
        avg: 1024
        xl: 1200
        xxl: 1440
    }
    String.prototype.capitalize = ->
        return this.charAt(0).toUpperCase() + this.slice(1)

    $(document).ready(->
        bindMainEvents()
        toggleMorePeople()
        menuScroll()
        buildPeopleGrid()
        setActiveMenuSection()
        basketHandler()
        quickImageHandler()
    )

    $(window).on('load', ->
        renderProgressiveImages(true)
        $('body').waitForImages(->
            parallaxImage()
            setImageSize()
        )
    )
    $(window).on('load resize', ->
        imageProportionsEvents()

        if window.innerWidth <= window.gridBreakpoints.md
            buildPeopleGrid()
        else
            buildPeopleGrid()
    )
    # TODO: temporary blocked
    #    if ( (getCookie('basket_count') || 0) < 1 )
    #        $('.jsHeaderBasket').hide()
    #        $('.jsHeaderMenuBasket').hide()

    # open dropdown list /gallery, pricing
    $(document).on('click', '.jsLinkButton', (e, index) ->
        if($(this).hasClass('active'))
            $(this).removeClass('active')
            $(this).siblings('.jsSlideList').slideUp()
            $('.jsOverlay').css('display', 'none')
        else
            $('.jsLinkButton').removeClass('active')
            $(this).addClass('active')
            $('.jsSlideList').slideUp()
            $(this).siblings('.jsSlideList').slideToggle()
            $('.jsOverlay').css('display', 'block')
    )

    # hide filters overlay
    $('.jsOverlay').on('click', ->
        $('.jsLinkButton').each(->
            if ($(this).hasClass('active'))
                $(this).trigger('click');
            else
            $('.jsOverlay').fadeOut()
        )
    )

    navLinkToBurger = (name, url) ->
        link = '<li class="header__dropdown__content__item"><a href="' + url + '">' + name + '</a></li>'
        destination = $('.jsHeaderBurgerAboutUs')
        destination.after(link)


    if (window.innerWidth <= window.gridBreakpoints.md)
        item = [
            {name: 'Gallery', url: window.location.origin + '/inspirations/'},
            {name: 'Customizer', url: window.location.origin + '/customizers/'},
            {name: 'Products', url: window.location.origin + '/products/'}
        ]
        i = 0
        while (i < item.length)
            navLinkToBurger(item[i].name, item[i].url)
            i++

    $('.cookie-info-close').on('click', (e) ->
        e.preventDefault()
        setCookie('cookies_accepted', 1, 365)
        $(this).parents('.cookie-info-container').remove()
    )

    bindMainEvents = ->
# disable autoplay on mobile browsers
        if (!window.isMobileUser)
            setTimeout (->
                $('video').trigger('play')
            ), 300

        getCookie = (c_name) ->
            if document.cookie.length > 0
                c_start = document.cookie.indexOf(c_name + '=')
                if c_start != -1
                    c_start = c_start + c_name.length + 1
                    c_end = document.cookie.indexOf(';', c_start)
                    if c_end == -1
                        c_end = document.cookie.length
                    return unescape(document.cookie.substring(c_start, c_end))
            ''
        $('.rw-words').each((index) ->
            longest = 0
            highest = 0
            $(@).find('span').each(->
                spanWidth = $(@).width()
                if spanWidth > longest
                    longest = spanWidth
                $(@).parent().width(longest + 70)
                $(@).css({
                    'left': 0
                    'right': 0
                    'margin': '0 auto'
                    'text-align': 'center'
                })
                $(@).parent().css({
                    'position': 'relative'
                })
            )
        )
        window.debug_mode = false
        debug_hosts = ['0.0.0.0', 'localhost', 'local.pl']
        for item of debug_hosts
            if (debug_hosts[item] == window.location.hostname)
                window.debug_mode = true

        $('.jsMySpecCopyClipboard').on('click', ->
            $(this).parents('.jsModalInfoContent').find('.jsMySpecShareLink').select()
            document.execCommand('copy')
            $(this).text('Copied!')
        )
        $('.header__logged-in__icon').on('click', ->
            $('.header__logged-in__dropdown, .header__logged-in__icon').toggleClass('active')
        )

        $('.material-input').each((index) ->
            if $(this).val()
                $(this).addClass('has-value')
            else
                $(this).removeClass('has-value')
        ).on('blur', ->
            if $(this).val()
                $(this).addClass('has-value')
            else
                $(this).removeClass('has-value')
        ).on('focus', ->
            $(this).removeAttr('readonly')
        )

        $('.box-grid__actions__button--view-all').on('click', ->
            if $(this).parent().siblings('.box-grid__content').hasClass('box-grid__content--mh')
                $(this)
                    .text('view less')
                    .parent()
                    .siblings('.box-grid__content')
                    .removeClass('box-grid__content--mh')
            else
                $(this)
                    .text('view all')
                    .parent()
                    .siblings('.box-grid__content')
                    .addClass('box-grid__content--mh')
        )
        $('#myFavouriteProducts').on('click', '.myspacestor-product-list__actions__button--view-all', ->
            if $(this).parent().siblings('.myspacestor-product-list__content').hasClass('myspacestor-product-list__content--mh')
                $(this)
                    .text('view less')
                    .parent()
                    .siblings('.myspacestor-product-list__content')
                    .removeClass('myspacestor-product-list__content--mh')
            else
                $(this)
                    .text('view all')
                    .parent()
                    .siblings('.myspacestor-product-list__content')
                    .addClass('myspacestor-product-list__content--mh')
        )

        $('.news-content-article__gallery__navigation__prev').on('click', ->
            $('.news-content-article__gallery__slider').slick('slickPrev')
            return
        )

        $('.news-content-article__gallery__navigation__next').on('click', ->
            $('.news-content-article__gallery__slider').slick('slickNext')
            return
        )
        $('.news-content-article__gallery__slider').slick({
            dots: false
            arrows: false
            infinite: true
            speed: 400
            cssEase: 'linear'
        })
        $(document).on('mouseover click', '.basket-list-item__option-dots', ->
            $(this).siblings('.basket-list-item__options').addClass('active')
        )
        $(document).on('mouseleave', '.basket-list-item', ->
            $(this).find('.basket-list-item__options').removeClass('active')
        )
        $('.news-content-side__inner').stick_in_parent({offset_top: 100})

        $('.sliderText-container').slick({
            dots: false
            arrows: false
            infinite: true
            speed: 800
            fade: true
            asNavFor: '.sliderImage-container'
            cssEase: 'linear'
        })

        $('.sliderImage-container').slick({
            dots: false
            arrows: false
            infinite: true
            speed: 800
            asNavFor: '.sliderText-container'
            cssEase: 'linear'
        })

        $('.spaceselect .select2').select2({
            minimumResultsForSearch: Infinity
            width: 367
        })
        $('.location-select__select').select2({
            minimumResultsForSearch: Infinity
            width: 480
            dropdownCssClass: 'contact-dropdown'
        })

        $('.open-chat, .jsOpenChatForm').off('click').on('click', ->
            trackEvent(null, 'chat open', null, true)
            $zopim.livechat.window.show()
            $('[data-test-id="ChatWidgetWindow"]').css({'zIndex': '160000011'})
        )
        $('.send-chat-message').off('click').on('click', ->
            message = $(this).data('message')
            $zopim.livechat.say(message)
        )
        $('.headquarter-section').on('click', ->
            $(this)
                .children('.headquarter-section__location')
                .toggleClass('active')
        )

    imageProportionsEvents = ->
        images = $('.jsImage')

        images.each(() ->
            setImageProportions(this, 4, 3, "y-position")
        )

    buildPeopleGrid = ->
        peopleGrid = $('.people__grid')
        if peopleGrid.length
            Shuffle = window.Shuffle
            shuffleInstance = new Shuffle(peopleGrid, {
                itemSelector: '.people-box'
                sizer: '.people-box-sizer'
                buffer: 1
            })
    toggleMorePeople = ->
        showMoreButton = $('.team-container__show-more__text')
        rowInvisible = $('.row-invisible')


        showMoreButton.on('click', (event) ->
            rowInvisible.slideToggle()
            $('.team-container__show-more__text--closed').toggle()
            $('.team-container__show-more__text--opened').toggle()
        )

        if ($(window).width() < window.gridBreakpoints.md) # mobile
            showMoreBrandsButton = $('.logo-container__show-more__text')
            showLessBrandsButton = $('.logo-container__show-more__text--closed')
            showLessBrandsButton.show()
            $('.logo-container__logo').slice(8).hide()
            showMoreBrandsButton.on('click', (event) ->
                $('.logo-container__show-more__text--closed').toggle()
                $('.logo-container__show-more__text--opened').toggle()
                $('.logo-container__logo').slice(8).slideToggle()
            )

    parallaxImage = ->
        if window.innerWidth >= window.gridBreakpoints.sm
            $('body').find('.parallax-container').each((index) ->
                that = $(this)
                imageParallax = $(this).find('.parallax-container__image')
                topDistance = $(this).offset().top
                imageContainer = $(this).height()
                imageHeight = imageParallax.height()
                sum = topDistance + imageContainer
                diff = imageHeight - imageContainer
                if topDistance >= window.innerHeight
                    scrollFixRatio = (imageHeight - imageContainer) / (window.innerHeight + imageContainer)
                else
                    scrollFixRatio = (imageHeight - imageContainer) / (topDistance + imageContainer)

                scroll = (scrollFixRatio, topDistance, diff, that) ->
                    imageParallax = that.find('.parallax-container__image')
                    topDistance = that.offset().top
                    imageContainer = that.height()
                    imageHeight = imageParallax.height()
                    sum = topDistance + imageContainer
                    diff = imageHeight - imageContainer
                    if topDistance >= window.innerHeight
                        scrollFixRatio = (imageHeight - imageContainer) / (window.innerHeight + imageContainer)
                    else
                        scrollFixRatio = (imageHeight - imageContainer) / (topDistance + imageContainer)

                    if topDistance >= window.innerHeight
                        scrollDistance = $(window).scrollTop() - (topDistance - window.innerHeight)
                    else
                        scrollDistance = $(window).scrollTop()
                    myTop = parseInt(scrollFixRatio * scrollDistance)
                    if (scrollDistance < sum) && (-myTop <= 0) && (-myTop >= -diff)
                        imageParallax.css('transform', 'translate3d(0, ' + -myTop + 'px, 0)')
                        return
                    return

                scroll(scrollFixRatio, topDistance, diff, that)
                waiting = false
                $(window).on('scroll', ->
                    if waiting
                        return
                    waiting = true
                    scroll(scrollFixRatio, topDistance, diff, that)
                    setTimeout (->
                        waiting = false
                        return
                    ), 75
                    return
                )
            )
    # section status on menu
    setActiveMenuSection = ->
        'use strict'
        section = document.querySelectorAll('.section-inside')
        sections = {}
        i = 0
        window.onscroll = ->
            Array::forEach.call section, (e) ->
                sections[e.id] = e.offsetTop - 150
                return
            scrollPosition = document.documentElement.scrollTop or document.body.scrollTop
            for i of sections
                `i = i`
                if sections[i] <= scrollPosition
                    $('.product-static__menu').children('.active').removeClass('active')
                    $('a[href*=' + i + ']').addClass('active')
            return

        return


    @setImageSize = ->
        $('body').find('.fixImgWidth').each((index) ->
            $container = $(this).parent()
            containerWidth = $container.width()
            containerHeight = $container.height()
            widthImg = $(this).width()
            heightImg = $(this).height()
            imageRatio = widthImg / heightImg
            divRatio = containerWidth / containerHeight
            if imageRatio <= divRatio
                $(this).css({
                    width: '100%'
                    height: 'auto'
                })
            else
                $(this).css({
                    width: 'auto'
                    height: '100%'
                })
        )

    menuScroll = ->
        types = ['black']

        types.map((type) ->
            if $('.header-container').hasClass('header-container--' + type)
                if $('.header').offset().top >= $('.header').height()
                    $('.header-container').removeClass('header-container--' + type)
                else
                    $('.header-container').addClass('header-container--' + type)
                $(window).on('scroll', ->
                    if $('.header').offset().top >= $('.header').height()
                        $('.header-container').removeClass('header-container--' + type)
                    else
                        $('.header-container').addClass('header-container--' + type)

                    hideMenuNav()
                )
        )

    # Hide Menu after scroll
    hideMenuNav = () ->
        headerNav = $('.jsHeaderNav')
        customizeSection = $('.jsProductCustomize')

        if customizeSection[0]
            customizeSectionHeight = customizeSection.height()
            sectionPosition = customizeSection[0].getBoundingClientRect().top

            if ((sectionPosition <= 0) && (customizeSectionHeight * (-0.5) <= sectionPosition))
                if (!headerNav.hasClass('jsHeaderNavHidden'))
                    headerNav.addClass('jsHeaderNavHidden')
                    headerNav.removeClass('jsVisibleNav')
                    headerNav.slideUp()
            else
                if (headerNav.hasClass('jsHeaderNavHidden'))
                    headerNav.removeClass('jsHeaderNavHidden')
                    headerNav.addClass('jsVisibleNav')
                    headerNav.slideDown()


    calculateVisibilityForDiv = (div$) ->
        windowHeight = $(window).height()
        docScroll = $(document).scrollTop()
        divPosition = div$.offset().top
        divHeight = div$.height()
        hiddenBefore = docScroll - divPosition
        hiddenAfter = divPosition + divHeight - (docScroll + windowHeight)
        if docScroll > divPosition + divHeight or divPosition > docScroll + windowHeight
            0
        else
            result = 100
            if hiddenBefore > 0
                result -= hiddenBefore * 100 / divHeight
            if hiddenAfter > 0
                result -= hiddenAfter * 100 / divHeight
            result

    calculateAndDisplayForAllDivs = ->
        $('.section').each ->
            div$ = $(this)
            if (div$.attr('data-visibility', '0') != 0)
                div$.attr('data-visibility', '0')
            calcRatio = calculateVisibilityForDiv(div$)
            percentageRatio = parseInt(calcRatio)
            if (div$.data('visibility') < percentageRatio)
                div$.data('visibility', percentageRatio)
                $(this).find('.bar-fix-width').css({
                    'width': percentageRatio + '%'
                })
                return
        return

    quickImageHandler = ->
        $('.image-quick-actions').on('click', ->
            objectId = $(this).data('object-id')
            objectType = $(this).data('object-type')
            imageUrl = $(this).data('image-url')
            favourite = $(this).data('favourite')
            pinUrl = $(this).data('pinurl')
            imageField = $(this).data('image-field')
            modal = $('#modalImageActions')
            baseUrl = modal.data('base-url')
            modal.attr('data-object-id', objectId)
            modal.attr('data-object-type', objectType)
            modal.attr('data-image-url', imageUrl)
            modal.attr('data-favourite', favourite)
            modal.attr('data-image-field', imageField)

            modal.find('#imageActionDownload').attr('href', imageUrl)
            modal.find('#imageActionPin').attr('href', pinUrl)

            modal.addClass('active')
        )
        $('#imageActionFavourite').on('click', (e) ->
            e.preventDefault()
            modal = $(this).parents('#modalImageActions')
            $.ajax({
                type: 'POST',
                url: '/myspacestor/change-favourite/',
                data: {
                    'type': modal.attr('data-object-type'),
                    'object_id': modal.attr('data-object-id'),
                    'source': modal.attr('data-source') || 'product-gallery-image',
                    'favourite': !modal.data('favourite'),
                    'image_field': modal.attr('data-image-field') || ''
                },
                success: (data) =>
                    if data.login_required
                        $('#modalImageActions').removeClass('active')
                        $('#modalSignIn').addClass('active')
                    else
                        added = data.is_liked
                        modal.data('favourite', !modal.data('favourite'))
                        $('#modalImageActions').removeClass('active')

                error: (data) =>
                    console.log('failure ' + data)

                headers: {
                    'X-CSRFToken': getCookie('csrftoken')
                }
            })
        )

    'use strict'
    results = {}
    sections = $('.section-inside')
    hasScrolled = ->
        sections.each(->
            if $(this).offset().top < window.pageYOffset + 150 and $(this).offset().top + $(this).height() > window.pageYOffset + 150
                id = $(this).attr('id')
                if id and window.location.hash != id
                    history.replaceState(null, null, '#' + id)
                    return false
        )
    waitingScrollBar = false
    $(window).on('scroll', ->
        if waitingScrollBar
            return
        waitingScrollBar = true
        calculateAndDisplayForAllDivs()
        hasScrolled()
        setTimeout (->
            waitingScrollBar = false
            return
        ), 100
        return
    )

    $(document).ready(->
        calculateAndDisplayForAllDivs()
        return
    )
    return

@.trackEvent = (category, action, label, transport = false, callback = false) ->
    callbackFn = callback or -> return true
    try
        title = document.title.split('|', 2)[1].trim()
    catch error
        title = document.title
    if not category
        category = $('[data-landing-name]').first().attr('data-landing-name') || title
    if not label
        label = title
    eventObj = {
        'hitType': 'event'
        'eventCategory': category.capitalize(),
        'eventAction': action.capitalize(),
        'eventLabel': label.capitalize(),
        hitCallback: callbackFn
    }
    if transport
        eventObj['transport'] = 'beacon'
    if window.debug_mode
        console.log('trackEvent ' + JSON.stringify(eventObj, null, 4))
    else
        return ga('send', eventObj)

@.openChat = -> (
    $zopim.livechat.window.show()
)

hideScrollBar = ->
    windowGlobal = window.innerHeight
    bodyGlobal = $('body').height()

    if (windowGlobal < bodyGlobal)
        $('body').css('overflow', 'hidden')

clearSlide = ->
    $('.jsModalSlideAddedProductBox').removeClass('active')
    $('.jsBasketQuoteDesc').each(->
        $(this).slideUp()
    )
    $('.jsModalSlide').find('.jsBasketQuoteArrow').each(->
        $(this).css('transform', 'rotate(180deg)')
        $(this).removeClass('active')
    )

# click on overlay
hideSlideOverlay = ->
    $(document).on('click', '.jsModalSlideOverlay', (e) ->
        if e.target == $(this)[0]
            $('body').css('overflow', 'auto')
            $(this).removeClass('active')
            $('.jsModalSlide').removeClass('active')
            clearSlide()
    )

@.getHotspots = ->
    $(document).ready(->
        hideSlideOverlay()

        createHotspot = (image, counter, id, hotspotId) ->
            elementHotspot = document.createElement('div')
            elementInsideHotspot = document.createElement('div')
            hotspotsParent = $(image).find('.jsHotspotsBoxOverlay')
            isSolutionHotspot = hotspotsParent.hasClass('jsSolutionHotspotCont');
            $(elementHotspot).attr({
                class: 'hotspot hotspot-' + counter + (isSolutionHotspot && ' jsSolutionHotspot'),
                'data-product-id': if isSolutionHotspot then null else id,
                'data-hotspot-id': if isSolutionHotspot then null else hotspotId,
                'data-solution-id': if isSolutionHotspot then hotspotId else null,
            })
            $(elementInsideHotspot).addClass('item__inside')
            hotspotsParent.append($(elementHotspot))
            $(elementHotspot).append($(elementInsideHotspot))
            $(elementHotspot).attr('data-image-size', $(elementHotspot).parents('.jsHotspotsBox').data('image-size'))

            # event to open modal slide
            $(elementHotspot).on('click', (e) ->
                e.stopPropagation()
                e.preventDefault()

                if isSolutionHotspot
                    window.SELECTED_SOLUTION = hotspotId.toString()
                    toggleShowSolutionInfo(SELECTED_SOLUTION)
                else
# Reset modal hotspot
                    $('.jsHotspotSlickContainer') && $('.jsHotspotSlickContainer').remove()

                    $(this).each(() ->
                        imageDataId = $(this).parents('.jsGalleryBoxesBox').data('image-id')
                        hotspotId = $(this).attr('data-hotspot-id');

                        if imageDataId
                            $.ajax({
                                type: 'POST'
                                data: {
                                    'image': imageDataId,
                                }
                                url: '/library/hotspots/slide/'
                                success: (data) =>
# Add content do modal
                                    $('.jsModalHotspotContent').html(data['content'])

                                    # Create slider
                                    $('.jsHotspotSlickContainer').slick({
                                        draggable: true,
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        arrows: true,
                                        dots: true,
                                    });

                                    # show current whitecutout in modal
                                    whitecutoutIndex = $('.jsHotspotSlickContainer').find('[data-product-id="' + hotspotId + '"]').attr('tabindex')
                                    $('.slick-dots').find('[tabindex="' + whitecutoutIndex + '"]').trigger('click')

                                    # Show modal
                                    $('.jsModalHotspot').addClass('active')

                                    # Set image id
                                    $('.jsModalSlideLargeImg').attr('src', imageDataId)

                                    # Set download link
                                    if $('.jsModalSliceLargeDownloadLink').length > 0
                                        $('.jsModalSliceLargeDownloadLink').attr('href', imageDataId)
                                    hideScrollBar()
                                error: (data) =>
                                    console.error(data)
                            })
                    )
            )

            return $(elementInsideHotspot)

        setHotspots = (item, elem) ->
            $(elem).parent().css({
                left: item.positionX + "%",
                top: item.positionY + "%"
            })

        images0 = ''
        images1 = ''
        images2 = ''
        images0List = []
        images1List = []
        images2List = []
        galleryImages = $(".jsHotspotsBox").map(-> return $(this).data('image-id')).get()
        isSolutionGallery = $(".jsHotspotsBox").hasClass('jsSolutionHotspotContainer')
        URL =
            if isSolutionGallery
                '/library/solution-hotspots/'
            else
                '/library/hotspots/'

        # set size id for each image
        $(document).find('.jsHotspotsBox').each(() ->
            imageWidth = $(this).width()
            if (imageWidth <= 149)
                $(this).attr('data-image-size', '-1')
            else if (imageWidth > 149 && imageWidth < 400)
                $(this).attr('data-image-size', '0')
            else if (imageWidth >= 400 && imageWidth < 750)
                $(this).attr('data-image-size', '1')
            else if (imageWidth >= 750)
                $(this).attr('data-image-size', '2')
        )

        generateImageList = (allImagesList, imagesList, size) ->
            allImagesList = $(".jsHotspotsBox").map(->
                if $(this).attr('data-image-size') == size
                    imagesList.push($(this).attr('data-image-id'))
            )

        # small images
        generateImageList(images0, images0List, '0')
        # medium images
        generateImageList(images1, images1List, '1')
        # large images
        generateImageList(images2, images2List, '2')

        if galleryImages
            $.ajax({
                type: "POST"
                url: URL
                data: {
                    'images0': images0List
                    'images1': images1List
                    'images2': images2List
                }
                success: (result) =>
                    if result.success == true
                        galleryImages.forEach((i, v) ->
                            imgSelector = '.jsHotspotsBox[data-image-id="' + i + '"]'
                            imageSizeId = 0
                            while imageSizeId < 3

# Sort images depending on the size
                                if result['data'][imageSizeId] != undefined && result['data'][imageSizeId][i] != undefined
                                    groupImages = 0
                                    idItem = 1

                                    # Generate all hotspots for each image
                                    while groupImages < result['data'][imageSizeId][i].length
                                        id = result['data'][imageSizeId][i][groupImages].version_id
                                        idHotspot = result['data'][imageSizeId][i][groupImages].id

                                        # Dont create hotspot if exsist with the same id
                                        if (!$('.hotspot[data-product-id="' + id + '"]').length)
                                            $(imgSelector).each(->
                                                newHotspot = createHotspot($(this), idItem, id, idHotspot)
                                                setHotspots(result['data'][imageSizeId][i][groupImages], newHotspot)
                                            )
                                        groupImages++
                                        idItem++
                                imageSizeId++
                        )
                error: (data) =>
                    console.log("failure " + data)
                headers: {
                    "X-CSRFToken": getCookie("csrftoken")
                }
            })
    )

@.isSupported = ->
    if (window.File && window.FileReader && window.FileList && window.Blob && window.XMLHttpRequest)
        return true;
    else
        return false;

@recaptchaCallback = (response) ->
    submit = $('.jsSubmitButton.jsCaptcha');
    navContactSubmit = $('.jsNavContactSubmitBtn');
    navContactRodo = $('.jsNavConactRodoCheckbox')[0]

    window.captchaResponse = response
    window.captchaVerified = response.length != 0
    submit.prop('disabled', !(window.rodoCheckbox && window.captchaVerified))
    navContactSubmit.prop('disabled', !(navContactRodo.checked && window.captchaVerified))
